import { EmeraldDialogTypes } from '../common/enumerations/emerald-dialog-types';
import { DeviceResponse, ErrorMap, StatusUpdateMap } from '../devices/rds-connection';
import { EmeraldErrorModal } from '../common/api/emerald-error';
import { popupMessage } from '../messages/business-logic/popup-message';

export const UNKNOWN_JPOS_CODE = 'Unknown_JposCode_Message';
export const UNHEALTHY_STATUS_MESSAGE = 'UNHEALTHY_STATUS_MESSAGE';
export const DEVICE_ERROR_MESSAGE = 'DEVICE_ERROR_MESSAGE';

export const showDeviceErrorMessageModal = (props: IDeviceMessage): void => {
  const {
    logicalName,
    extendedErrorCodeMessage,
    errorCodeMessage,
    extendedErrorCode,
    errorCode,
  } = (props.data.metaDataMap as unknown) as ErrorMap;

  const subMessage = extendedErrorCodeMessage || errorCodeMessage || UNKNOWN_JPOS_CODE;
  const subMessageArg = extendedErrorCode || errorCode;

  const errorModal = new EmeraldErrorModal({
    type: EmeraldDialogTypes.Error,
    message: DEVICE_ERROR_MESSAGE,
    subMessage,
    messageArgs: { arg: logicalName },
    subMessageArgs: { arg: subMessageArg },
    hideCancelButton: true,
  });

  popupMessage(errorModal);
};

export const showDeviceUnhealthyStatusMessageModal = (props: IDeviceMessage): void => {
  const { logicalName, statusMessage, status } = (props.data
    .metaDataMap as unknown) as StatusUpdateMap;

  const subMessage = statusMessage || UNKNOWN_JPOS_CODE;

  const statusModal = new EmeraldErrorModal({
    type: EmeraldDialogTypes.Warning,
    message: UNHEALTHY_STATUS_MESSAGE,
    subMessage,
    messageArgs: { arg: logicalName },
    subMessageArgs: { arg: status },
    hideCancelButton: true,
  });

  popupMessage(statusModal);
};

export interface IDeviceMessage {
  data: DeviceResponse;
}
